import React, { useEffect } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { setPageSeo } from "../lib/seo";
import { BUSINESS } from "../lib/business";

export default function Shipping() {
  useEffect(() => {
    window.scrollTo(0, 0);
    setPageSeo({
      title: "Shipping & Delivery — DevzCorner",
      description:
        "Delivery timelines for DevzCorner digital services, hardware builds, and 3D-printed products from Bengaluru, India.",
      path: "/shipping",
    });
  }, []);

  return (
    <main className="relative bg-ink-0 text-white min-h-screen flex flex-col">
      <Navbar />
      <div className="flex-grow pt-32 pb-24 px-6 md:px-10 max-w-4xl mx-auto w-full">
        <h1 className="font-display text-4xl md:text-5xl mb-8">Shipping &amp; Delivery</h1>
        <div className="prose prose-invert max-w-none text-zinc-400 font-light leading-relaxed space-y-6">
          <p>Last updated: October 2026</p>
          <p>
            This policy explains how {BUSINESS.legalName} delivers digital services and physical products from our studio in Bengaluru, India.
          </p>

          <h2 className="text-white text-2xl font-display mt-8 mb-4">1. Digital Delivery</h2>
          <p>
            Most services (software development, AI integration, consulting) are delivered digitally. Source code, environments, and documentation are handed over via secure channels (e.g. GitHub, cloud accounts, or your infrastructure). Delivery dates for each milestone are stated in your Statement of Work (SOW). Typical first milestone delivery is within <strong className="text-zinc-300">2–4 weeks</strong> of kickoff, unless the SOW states otherwise.
          </p>

          <h2 className="text-white text-2xl font-display mt-8 mb-4">2. Physical Products &amp; Hardware</h2>
          <p>
            Hardware builds and 3D-printed products ship from Bengaluru after fabrication and quality checks.
          </p>
          <ul className="list-disc pl-6 space-y-2">
            <li>
              <strong className="text-zinc-300">Processing / fabrication:</strong> typically <strong className="text-zinc-300">7–21 business days</strong> after order confirmation (confirmed before payment for custom builds).
            </li>
            <li>
              <strong className="text-zinc-300">Domestic shipping (India):</strong> usually <strong className="text-zinc-300">3–7 business days</strong> after dispatch via standard commercial carriers.
            </li>
            <li>
              <strong className="text-zinc-300">International shipping:</strong> usually <strong className="text-zinc-300">7–21 business days</strong> after dispatch, depending on destination and customs.
            </li>
            <li>
              <strong className="text-zinc-300">Tracking:</strong> a tracking number is emailed once the shipment is handed to the carrier.
            </li>
          </ul>

          <h2 className="text-white text-2xl font-display mt-8 mb-4">3. International Orders</h2>
          <p>
            International shipments may incur customs duties, taxes, or import fees payable by the recipient. We are not responsible for carrier or customs delays beyond our control.
          </p>

          <h2 className="text-white text-2xl font-display mt-8 mb-4">4. Delays</h2>
          <p>
            If supply-chain, weather, or other issues delay delivery, we will notify you by email or phone as soon as we know.
          </p>

          <h2 className="text-white text-2xl font-display mt-8 mb-4">5. Contact</h2>
          <p>
            {BUSINESS.legalName}<br />
            {BUSINESS.addressOneLine}<br />
            Phone:{" "}
            <a href={BUSINESS.phoneHref} className="text-white underline hover:text-zinc-300 transition-colors">
              {BUSINESS.phoneDisplay}
            </a>
            <br />
            Email:{" "}
            <a href={`mailto:${BUSINESS.email}`} className="text-white underline hover:text-zinc-300 transition-colors">
              {BUSINESS.email}
            </a>
          </p>
        </div>
      </div>
      <Footer />
    </main>
  );
}
